export default __webpack_public_path__ + "images/MU.bd42e24.png";